__turbopack_context__.v({
  "active": "Header-module__vcZAwq__active",
  "btnPrimary": "Header-module__vcZAwq__btnPrimary",
  "burger": "Header-module__vcZAwq__burger",
  "burgerLine": "Header-module__vcZAwq__burgerLine",
  "burgerOpen1": "Header-module__vcZAwq__burgerOpen1",
  "burgerOpen2": "Header-module__vcZAwq__burgerOpen2",
  "burgerOpen3": "Header-module__vcZAwq__burgerOpen3",
  "header": "Header-module__vcZAwq__header",
  "logoFull": "Header-module__vcZAwq__logoFull",
  "nav": "Header-module__vcZAwq__nav",
  "navLink": "Header-module__vcZAwq__navLink",
  "navLinks": "Header-module__vcZAwq__navLinks",
  "navLinksOpen": "Header-module__vcZAwq__navLinksOpen",
  "navLogo": "Header-module__vcZAwq__navLogo",
});
